import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_daiji",
  "use": "icon-icon_daiji-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-icon_daiji\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h20v20H0z\" /><path d=\"M18.333 8.333v8.334c0 .46-.373.833-.833.833h-15a.833.833 0 0 1-.833-.833V8.333h16.666Zm0-1.666H1.667V3.333c0-.46.373-.833.833-.833h15c.46 0 .833.373.833.833v3.334ZM12.5 13.333V15h3.333v-1.667H12.5Z\" fill=\"#4869E8\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol